import React from "react";
//#region types
import { DialogEnums } from "models/enums";
//#endregion
//#region components
import { Grid, Container } from "@mui/material";
import { DialogContainer, useNavigationHistory, BreadCrumb } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import Logo from "images/logo-small.png";
import clsx from "clsx";

const ErrorView: React.FC = () => {
  const { goBack } = useNavigationHistory();

  return (
    <div className={cssExports.errorViewBackground}>
      <DialogContainer
        isOpen={true}
        title={<BreadCrumb prevItems={[]} current={"Not Found"} />}
        dialogType={DialogEnums.DialogType.FullScreen}
        closeDialog={goBack}
      >
        <>
          <Container maxWidth="sm" className={clsx(cssExports.errorViewContainer, cssExports.companyNotFoundContainer)}>
            <Grid container className={cssExports.errorViewContent} direction="column" justifyContent="center">
              <Grid item container spacing={0} justifyContent="center" className={cssExports.logoImg}>
                <img src={Logo} />
              </Grid>
              <Grid item container justifyContent="center" spacing={0} className={cssExports.title}>
                Oops!
              </Grid>
              <Grid item container justifyContent="center" spacing={0}>
                Seems like you were trying to access something you don't have permission to
              </Grid>
            </Grid>
          </Container>
        </>
      </DialogContainer>
    </div>
  );
};

export default ErrorView;
